"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleYearDeserialize = void 0;
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
function vehicleYearDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        value: (0, deserializeNumber_1.deserializeNumber)(object.value),
    };
}
exports.vehicleYearDeserialize = vehicleYearDeserialize;
